import { useCreateLayer } from 'common/CreateLayerButton/useCreateLayer'
import { ButtonProps } from '../Button/Types'
import { Button } from '../Button'
import { ReactComponent as CreateLayerIcon } from 'assets/icons/edit16.svg'
import { Variables } from 'hooks/queries/layers/useCreateLayer'

interface Props extends Pick<ButtonProps, 'isDisabled' | 'variant' | 'size' | 'className' | 'frontIcon'> {
  articleKey: string
  children?: string
  dataTestId?: string
  layerVariables?: Variables
}

export const EditOnNewLayerButton = ({
  articleKey,
  children = 'Edit on Layer',
  variant,
  size,
  isDisabled,
  className,
  frontIcon = CreateLayerIcon,
  layerVariables,
  dataTestId,
}: Props) => {
  const { createLayer, isLoading: isCreating } = useCreateLayer({ articleKey })

  const handlePress = () => createLayer(layerVariables)

  return (
    <Button
      isDisabled={isCreating || isDisabled}
      onPress={handlePress}
      variant={variant}
      size={size}
      frontIcon={frontIcon}
      className={className}
      data-testid={dataTestId}
    >
      {children}
    </Button>
  )
}
